import CustomCard from '../../../../../../components/CustomCard';
import {
    ArrowRightIcon,
    IconCalendarPerson,
    IconCloseChip,
    PlusIconsOptions
} from '../../../../../../components/buttons/IconButtons';
import React from 'react';
import NotInformation from '../../../../../../components/NotInformation';
import { useTranslation } from 'react-i18next';
import ButtonActionsCard from '../../../../../../components/buttons/ButtonActionsCard';
import ButtonAction from '../../../../../../components/buttons/ButtonAction';
import ZoneItem from './ZoneItem';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const WorkShiftsCard = (
    {
        workShiftAccessTime,
        showNoInformation = true,
        showModal, setShowModal,
        onClickAdded = null,
        setWorkShift
    }
) => {
    const { t } = useTranslation();
    return (
        <>
            {workShiftAccessTime && workShiftAccessTime?.content?.length > 0 ?
                <>
                    <CustomCard classes="w-100" classCard="card-shades-300-100">

                        <div className="d-flex justify-content-between align-content-center">
                            <div className="d-flex justify-content-start align-content-center">
                                <div><IconCalendarPerson className="icon-color-shades-950" width={16} height={16} /></div>
                                <p className="pl-3 fs-14px ibl-font-w-600 font-color-general-950">{t("i_entry_general_access")}</p>
                            </div>
                            <div>
                                <IconCloseChip
                                    className='icon-color-shades-400'
                                    onClick={()=>{
                                        setWorkShift(null);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="border-bottom-shades-300 my-3" />
                        {workShiftAccessTime?.content?.map((item, index) => (
                            <div className="mb-2 px-0" id={`id_${item?.zoneId || index}`} key={`key_${item?.zoneId || index}`}>
                                <CustomCard classes="w-100" classCard="card-shades-200-100" classContent="p-10px">
                                    <ZoneItem
                                        item={item}
                                    />
                                </CustomCard>
                            </div>
                        ))}

                        {workShiftAccessTime?.totalElements >= 5 &&
                            <div className="d-flex justify-content-end pt-2">
                                <ButtonActionsCard
                                    id='btn_wsc_show_full_schedules'
                                    name='show_full_schedules'
                                    iconProps='btn-icon-svg-12px icon-color-general-950'
                                    Icon={ArrowRightIcon}
                                    onClick={() => {
                                        setShowModal(true);
                                    }}
                                />
                            </div>
                        }
                    </CustomCard>

                    <div className="d-flex justify-content-end pt-4 pb-3 pb-sm-0">
                        <ButtonAction
                            id='btn_wsc_add_work_shift'
                            name='add_work_shift'
                            className='btn-outlined-secondary-600-25'
                            Icon={PlusIconsOptions}
                            splitName={false}
                            disabled={false}
                            onClick={() => {
                                if (onClickAdded) onClickAdded();
                            }}
                        />
                    </div>
                </>
                :
                <>
                    {showNoInformation && <NotInformation text={t('no_information')} card={true} className={'h-250px'} />}
                </>
            }
        </>
    );
}

export default WorkShiftsCard
